module.exports = __webpack_public_path__ + "static/media/Haltéro_musculation.00fb1d7e.png";